import api from '../../../../api/client'

export async function listJobMasters(params) {
  const { data } = await api.get('/masters/job-masters/', { params })
  return data
}

export async function getJobMasterDetail(id) {
  const { data } = await api.get(`/masters/job-masters/${id}`)
  return data
}

export async function createJobMaster(payload) {
  const { data } = await api.post('/masters/job-masters/', payload)
  return data
}

export async function updateJobMaster(id, payload) {
  const { data } = await api.put(`/masters/job-masters/${id}`, payload)
  return data
}

export async function archiveJobMaster(id) {
  const { data } = await api.post(`/masters/job-masters/${id}/archive`)
  return data
}

export async function unarchiveJobMaster(id) {
  const { data } = await api.post(`/masters/job-masters/${id}/unarchive`)
  return data
}

export async function deleteJobMaster(id) {
  const { data } = await api.post(`/masters/job-masters/${id}/delete`)
  return data
}

export async function getJobMasterDropdown(taskMasterId = null) {
  const params = {}
  if (taskMasterId) {
    params.taskMasterId = Number(taskMasterId)
  }
  const { data } = await api.get('/masters/job-masters/dropdown', { params })
  return Array.isArray(data) ? data : []
}
